import { colors } from "goi_common";
import { BugoShareSangjuItem } from "./BugoShareSangjuItem";

export const BugoNativeShareChoiceSelfItem = ({
  relation,
  name,
  index,
  isChecked,
  onChange,
}: {
  relation: string;
  name: string;
  index: number;
  isChecked: boolean;
  onChange: () => void;
}) => {
  return (
    <BugoShareSangjuItem.Base>
      <BugoShareSangjuItem.Relation>{relation}</BugoShareSangjuItem.Relation>
      <BugoShareSangjuItem.Name>{name}</BugoShareSangjuItem.Name>
      <BugoShareSangjuItem.Radio
        index={index}
        isChecked={isChecked}
        checkedColor={colors.orange650}
        onChange={onChange}
      />
    </BugoShareSangjuItem.Base>
  );
};
